export default __webpack_public_path__ + "static/media/twenty-one.dcdb5748.png";